require('dotenv').config()
export const REACT_APP_API = process.env.REACT_APP_API
export const REACT_APP_DEV_TOOLS = process.env.REACT_APP_DEV_TOOLS